import * as Sentry from '@sentry/react'

/**
 * Initialize Sentry as early as possible.
 * Accepts an env object (default: import.meta.env) for testability.
 */
export function initSentry(env = import.meta.env) {
  const dsn = env.VITE_SENTRY_DSN
  if (!dsn) {
    // No DSN configured: silently skip (e.g. local dev without Sentry).
    return
  }

  Sentry.init({
    dsn,
    environment: env.VITE_SENTRY_ENVIRONMENT || 'development',
    release: env.VITE_SENTRY_RELEASE || undefined,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: Number.parseFloat(env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '1.0'),
    tracePropagationTargets: [
      'localhost',
      /^\/api\//,
      /^https:\/\/.*\.flexible-universe\.com\/api/,
    ],
    replaysSessionSampleRate: Number.parseFloat(env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? '0.1'),
    replaysOnErrorSampleRate: Number.parseFloat(env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? '1.0'),
    enableLogs: true,
  })
}
